import { io } from 'socket.io-client';

let socket = null;

export function initSocket(token) {
  socket = io(process.env.VUE_APP_URL_SOCKET_IO, {
    auth: { token },
    transports: ['websocket'],
  });

  return socket;
}

export function getSocket() {
  return socket;
}
